<template>
  <div>
    <template v-if="studentInfo">
      <div>{{ studentInfo.fullname }}</div>
      <div>{{ studentInfo.furigana }}</div>
      <div v-if="studentInfo.class_info">
        {{ studentInfo.class_info.name }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SeatMapStudent',
  props: {
    studentList: {
      type: Array,
      require: true
    },
    studentId: {
      type: Number,
      require: true
    }
  },
  data () {
    return {
      studentInfo: null
    }
  },
  created() {
    this.studentInfo = this.studentList.find((item) => item.id === this.studentId)
  }
}
</script>
